import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TitleWithIcon from "../../components/layout/pageTitle/PageTitle";
import kbIcon from "../../media/template_plan.png";
import BlockTitle from "../../components/layout/blockTitle/BlockTitle";
import "../patient/tabs/patientRecommendations.css";
import "../../components/layout/tiptapEditor/tiptapEditor.css";
import "./Instructions.css";

export default function InstructionPageShell({ blockTitle, pageTitle, body, children }) {
  const { t } = useTranslation("instructions");

  useEffect(() => {
    document.title = pageTitle || blockTitle || t("shell.title");
  }, [pageTitle, blockTitle, t]);

  return (
    <Container fluid="md">
      <Row>
        <Col>
          <div className="patient-page">
            <TitleWithIcon
              icon={kbIcon}
              title={t("shell.title")}
              showStatus={false}
              status={""}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="tab-content block page-block">
            <Row>
              <Col>
                <BlockTitle title={blockTitle} buttons={[]} />
              </Col>
            </Row>

            <Row>
              <Col>
                <div className="page">
                  <div className="page-content">
                    <div className="patient-recommendations">
                      <div className="recommendation-item ">
                        <h5>{blockTitle}</h5>
                        {body ? (
                          <div
                            className="tiptap-content instruction-body"
                            dangerouslySetInnerHTML={{ __html: body }}
                          />
                        ) : (
                          <div className="tiptap-content instruction-body">
                            {children}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
